import React, { useEffect, useState } from 'react'
import { message, Space, Table } from 'antd'
import Main from '../../cpn/Main'
import MediaAdd from './MediaAdd'
import { useBnsMeiJieDelMutation, useBnsMeiJieListQuery } from '../../store/ReactWebSiteApi'
import MediaEdit from './MediaEdit'
import ModalDel from '../../cpn/ModalDel'
import MediaCheck from './MediaCheck'

function MediaList() {
    const [list, setList] = useState();    
    const {data, isSuccess} = useBnsMeiJieListQuery({bmj_e_id:localStorage.getItem('e_id')},{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bmj_id:key,bmj_name,bmj_ctime,bmj_cname,bmj_bg_name,bmj_dept_id,bmj_dept_name,bmj_meijie_name,bmj_riqi} = item;
                    return item = {key,bmj_name,bmj_ctime,bmj_cname,bmj_bg_name,bmj_dept_id,bmj_dept_name,bmj_meijie_name,bmj_riqi}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bmj_ctime;
                    let bTimeString = b.bmj_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'bmj_name',
            title: '媒介名称',            
            dataIndex:'bmj_name', 
            render:(text,record) => {
                return  <MediaCheck
                            bmj_name={record.bmj_name}
                            bmj_id={record.key}
                        />
            }           
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.bmj_ctime + record.bmj_cname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <MediaEdit
                            bmj_id={record.key}
                        />            
                        <ModalDel onOk={() => {
                            del({bmj_id:record.key}).then((res) => {
                                console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('删除成功！')                                                                              
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('删除失败！'+res.data.Message)
                                }
                            })
                        }} />   
                    </Space>
                </>
            }
        },
    ]   
    //删除
    const [del] = useBnsMeiJieDelMutation()
    return (
        <Main t1='推广'  t2='媒介'>
            <Space size='large'>
                <MediaAdd />             
            </Space> 
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}} 
                style={{marginTop:"20px"}}
            />
        </Main>
    )
}

export default MediaList